import axios from "axios";

const API_URL = process.env.REACT_APP_API_URL + "/api/incidents";

export const fetchIncidents = async () => {
  const response = await axios.get(API_URL);
  return response.data;
};

export const reportIncident = async (data, token) => {
  const response = await axios.post(API_URL, data, {
    headers: { Authorization: `Bearer ${token}` },
  });
  return response.data;
};
